import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';

export const saveAsFile = (response: AxiosResponse | { data: Blob; filename: string }): void => {
  if ('data' in response && 'filename' in response) {
    saveAs(response.data, response.filename);
    return;
  }

  // Extract filename from content-disposition header if available
  let filename = 'download';
  const contentDisposition = response?.headers['content-disposition'];
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1].replace(/[/"]/g, '').trim();
    }
  } else {
    // If no content-disposition header, generate filename based on content-type
    const contentType = response?.headers['content-type'];
    const timestamp = new Date().toISOString().replace(/[\W]/gi, '');
    if (contentType?.includes('csv')) {
      filename = `export_${timestamp}.csv`;
    } else if (contentType?.includes('json')) {
      filename = `export_${timestamp}.json`;
    } else if (contentType?.includes('pdf')) {
      filename = `export_${timestamp}.pdf`;
    }
  }

  const content = response?.headers['content-type'];
  if (content === 'application/json; charset=utf-8') {
    const blob = new Blob([JSON.stringify(response?.data)], { type: 'application/json' });
    saveAs(blob, filename);
  } else {
    const blob = new Blob([response?.data as unknown as BlobPart]);
    saveAs(blob, filename);
  }
};
